<template>
  <span>
    <span
      :id="'tooltip-color-' + item.Colour+item.Item_id"
      v-on:click="$emit('item-clicked',item.Item_id)"
    >
      <div
        class="circle mr-2 bordered"
        :class="{active: active,black: item.Colour.toLowerCase() == 'black'}"
        :style="{ background: getColorBackground(item.Colour.toLowerCase()) }"
      ></div>
    </span>
    <b-tooltip :target="'tooltip-color-' + item.Colour+item.Item_id" triggers="hover">
      <b>{{ item.trueColour }}</b>
    </b-tooltip>
  </span>
</template>
<script>
export default {
  props: ["item", "active"],
  mounted() {},
  methods: {
    getColorBackground: function (color) {
      if (color.includes("/")) {
        let Colors = color.split("/");
        return `linear-gradient(90deg, ${Colors[0]} 50%, ${Colors[1]} 50%)`;
      }
      return color;
    },
  },
};
</script>
<style scoped>
.bordered {
  border: 1px solid black;
  border-radius: 50%;
}
.circle {
  background: black;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
}
.circle.active {
  width: 25px;
  height: 25px;
  border: 5px solid black;
}
</style>